<template>
    <div>
        <!-- Modal Component -->
        <b-modal v-model="openModal" title="New Designation" size="lg" ok-title="Save All Designations" ok-variant="success" no-fade @hide="handleHide" @hidden="handleHidden" @ok="handleOk" ref="designationCreateModal" :ok-disabled="saving || designations.length === 0" :cancel-disabled="saving" :no-close-on-backdrop="true" scrollable>

            <div v-if="loading" class="text-center">
                <i class="fa fa-circle-o-notch fa-spin"></i> Loading
            </div>
            <template v-else>
                <div class="form-group row">
                    <label class="col-md-2 col-form-label text-sm-right">
                        State:
                    </label>
                    <div class="col-md-3">
                        <select v-model="state_id" class="form-control" :class="{'is-invalid': errors.state_id}">
                            <option :value="null">-- Select a State --</option>
                            <option v-for="state in state_list" :value="state.state_id">{{ state.state_code }}</option>
                        </select>

                        <span v-if="errors.state_id" class="text-danger">
                            {{ errors.state_id }}
                        </span>
                    </div>

                    <label class="col-md-2 col-form-label text-sm-right">Minority Cert:</label>
                    <div class="col-md-4">
                        <select v-model="designation_id" class="form-control" :class="{'is-invalid': errors.designation_id}">
                            <option :value="null">-- Select a Designation --</option>
                            <option v-for="(name, id) in designation_list" :value="id">{{ name }}</option>
                        </select>

                        <span v-if="errors.designation_id" class="text-danger">
                            {{ errors.designation_id }}
                        </span>
                    </div>
                    <div class="col-md-1">
                        <b-button variant="info" title="Add a Designation" @click="newDesignation" :disabled="this.state_id === null || this.designation_id === null"><i class="fa fa-plus-circle"></i></b-button>
                    </div>
                </div>
                <hr>

                <div class="alert alert-info">
                    Select a state and designation above, then use the plus button to add it to the list.
                    <br>
                    Once all applicable designations have been added, attach the appropriate file to each one.
                    <br>
                    When complete, hit Save All Designations to finish adding designations.
                </div>

                <label class="col-form-label">Unsaved designations</label>
                <div v-if="errors.add_designations" class="text-danger">
                    <span v-for="error in errors.add_designations">
                        {{ error }}
                    </span>
                </div>
                <div class="form-group">
                    <table class="table" v-if="designations.length > 0">
                        <thead>
                            <tr>
                                <td>State - Designation</td>
                                <td>Certificate/Award Letter</td>
                                <td>Certifying Agency <i class="fa fa-sm fa-asterisk text-danger"></i></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(designation, index) in designations">
                                <td width = "120 px" style="padding: 4px;">
                                    <b-button variant="danger" size="xs" v-on:click="deleteDesignation(index)" title="Delete Designation"><i class="fa fa-trash"></i></b-button>
                                    {{ getStateCode(designation.state_id) }} - {{ designation_list[designation.designation_id] }}
                                </td>
                                <td width = "180 px">
                                    <b-form-file v-model="files[index]" :key="designation.designation_id" plain></b-form-file>
                                </td>
                                <td width = "180 px">
                                    <b-form-textarea v-model="designation.certifying_agency" :key="designation.designation_id" type="text" placeholder="Enter name of the certifying agency (city, DOT, federal agency, etc.) and the expiration date of your certification - or - self-certified" rows="2" :class="{'is-invalid': errors['designations.'+index+'.certifying_agency']}"></b-form-textarea>

                                    <span v-if="errors['designations.'+index+'.certifying_agency']" class="text-danger">
                                        <span v-for="error in errors['designations.'+index+'.certifying_agency']">{{ error }}</span>
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <p v-else>
                        -- No Unsaved Designations --
                    </p>
                </div>

                <template v-if="this.$store.state.subcontractor.designations.length > 0">
                    <label class="col-form-label">Existing designations</label>
                    <div class="form-group">
                        <dl>
                            <dd v-for="designation in this.$store.state.subcontractor.designations">
                                {{ getStateCode(designation.state_id) }} - {{ designation_list[designation.designation_id] }}
                            </dd>
                        </dl>
                    </div>
                </template>
            </template>
        </b-modal>
    </div>
</template>

<script>
    export default {
        props: {
            subcontractorId: {
                type: Number,
                default: null,
            },
        },

        data: function() {
            return {
                openModal: false,
                loading: true,
                saving: false,
                errors: {},
                state_id: null,
                designation_id: null,
                designation_list: {},
                designations: [],
                files: [],
            }
        },

        computed: {
            state_list() {
                return this.$store.state.state_list ? this.$store.state.state_list : [];
            },

            // We're setting disabled, so true means we CANNOT add, so if we don't have the ids, or they exist already, return true
            cannot_add() {
                if (!this.state_id || !this.designation_id)
                {
                    return true;
                }

                // Do we have any on the current modal?
                let have_now = this.designations.some((item) => {
                    return (item.state_id == this.state_id && item.designation_id == this.designation_id);
                });

                // Do we have any on the subcontractor already?
                let have_previous = this.$store.state.subcontractor.designations.some((item) => {
                    return (item.state_id == this.state_id && item.designation_id == this.designation_id);
                });

                return (have_now || have_previous);
            },
        },

        methods: {
            getStateCode(state_id) {
                // Doesn't work in IE, FML
                // return this.state_list.find(state => state.state_id == state_id).state_code;
                return this.state_list.filter(state => state.state_id == state_id)[0].state_code;
            },

            handleHide(bvEvt){

            },

            handleHidden(bvEvt){
                //Reset the values
                this.designations = [];
                this.errors = {};
                this.file = null;
                this.designation_id = null;
                this.state_id = null;
            },

            handleOk: function(bvEvt) {

                //Stops the modal from closing
                bvEvt.preventDefault();

                this.saveDesignation();
            },

            showModal(){
                //Show it
                this.openModal = true;
            },

            getFormResources(){
                //Loading indicator
                this.loading = true;

                //Get the resources
                this.$http
                    .get('subcontractors/designation')
                    .then(response => {
                        //Set it
                        this.designation_list = response.data.designations;

                        //Loading false
                        this.loading = false;
                    });
            },

            newDesignation() {
                if (this.cannot_add)
                {
                    this.$toastr.error('This designation has already been added');
                    return;
                }

                this.designations.push({'state_id': this.state_id, 'designation_id': this.designation_id});
                this.files.push(null);

                this.state_id = null;
                this.designation_id = null;
            },

            deleteDesignation(index) {
                this.designations.splice(index, 1);
                this.files.splice(index, 1);
            },

            saveDesignation(){
                this.saving = true;

                //console.log(this.designations);
                //Send it
                this.$http
                .postWithFiles('subcontractors/designations/' + this.subcontractorId, {'designations': this.designations}, this.files)
                .then(response => {
                    //Alert the user?
                    this.$toastr.success('Designations Added');

                    //Update the Store
                    this.$store.commit('updateDesignationsBulk', response.data);

                    //Close the modal
                    this.$refs.designationCreateModal.hide();

                })
                .catch(error => {
                    //Check for error
                    if(error.response && error.response.status === 422)
                    {
                        //Display validation errors
                        this.errors = error.response.data
                    }
                    else
                    {
                        console.log(error);

                        //Alert the user
                        this.$toastr.error('Something Went Wrong. Check the Console for Error Logs');
                    }
                })
                .then(response => {
                    //Show loading
                    this.saving = false;
                });
            }
        },

        mounted() {
            //Set the height
            //this.$refs.designationCreateModal.$refs.body.style['max-height'] = window.innerHeight * 0.75 + 'px';

            //Get the resources
            this.getFormResources();
        }
    }
</script>